<template>
  <div class="dropdown_wrapper">
    <label v-if="textLabel" class="text_label has_mb">{{ textLabel }}</label>
    <div class="dropdown_select" :class="selectClass">
      <div class="dropdown_select_current" v-on:click="$emit('toggleDropdown')">
        <span class="select_current_text" :class="textAlign">
          <span v-if="placeholder && !current">{{ placeholder }}</span>
          <img width="24" height="19" :src="require(`@/assets/images/flags/${flag(current)}.svg`)">
          {{ current }}
        </span>
        <ArrowDownIcon />
      </div>

      <div class="dropdown_select_wrap">
        <div v-bar>
          <ul class="dropdown_select_list">
            <li v-for="(option, index) in options" :key="index" :class="[isCurrent(option), isDivider(option)]"
              v-on:click="emitSelectDropdown(option)">

              <img width="24" height="24" :src="require(`@/assets/images/flags/${flag(option)}.svg`)">
              {{ option }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowDownIcon from "@/assets/img/arrow_down.svg?inline";
export default {
  name: "DropdownSelect",
  components: {
    ArrowDownIcon
  },
  props: {
    textLabel: String,
    selectClass: String,
    current: String,
    selectOptions: Array,
    placeholder: String,
    fullHeight: {
      type: Boolean,
      default: false
    },

    skipHeight: {
      type: Boolean,
      default: false
    },
    textAlign: {
      type: String,
      default: ''
    },
  },
  data: function () {
    return {
      options: this.selectOptions,
      toggle: false
    };
  },
  computed: {
    triggerDropdown() {
      return this.$store.state.triggerDropdown;
    }
  },

  watch: {
    triggerDropdown() {
      this.$emit("resetSelectClass");
    }
  },

  methods: {
    isCurrent(value) {
      return value === this.current ? "active" : "";
    },
    isDivider(value) {
      return value === "_divider" ? "divider" : "";
    },

    emitSelectDropdown(option) {
      if (option == "_divider") return;
      this.$emit("selectDropdown", option);
    },
    flag(currency) {
      const map = {
        USD: "us",
        EUR: "eu",
        GBP: "gb",
        CAD: "ca",
        AUD: "au"
      };

      return map[currency.toUpperCase()] || currency.toLowerCase();
    },
    printOption(option) {
      return option == "_divider" ? "" : option;
    }
  }
};
</script>

<style>
.dropdown_select_list {
  padding-right: 0px !important;
}

.dropdown_wrapper .dropdown_select.active .vb {
    -webkit-box-shadow: 1px 1px 2px #e0e0e0b3;
    box-shadow: 1px 1px 2px #e0e0e0b3;
}

.dropdown_wrapper .dropdown_select_list li {
  background-color: #fff;
  color: #242424;
  display: flex;
  align-items: center;
  gap: 5px;
}

.dropdown_wrapper .dropdown_select_list li:hover,
.dropdown_wrapper .dropdown_select_list li.active {
  background-color: #fff;
  color: #fa6400;
}

.dropdown-overlay {
  position: absolute;
}

.select_current_text_align {
  text-align: initial;
}

.dropdown_wrapper {
  display: flex;
  width: 280px;
  justify-content: center;
  gap: 15px;
  align-items: center;
}

.dropdown_wrapper .select_current_text {
  width: 76px;
  display: flex;
  align-items: center;
  gap: 5px;
  color: #242424;
  font-size: 1rem;
}
.dropdown_wrapper .dropdown_select_current{
  border-color: #ececec;
}
.dropdown_wrapper .dropdown_select_current:hover{
  border-color: #ececec;
}
.dropdown_wrapper .dropdown_select_current:hover .select_current_text {
  color: #242424;
}

.dropdown_wrapper .dropdown_select_current:hover svg path {
  fill: #242424;
}
</style>
